<script setup lang="ts">
  import { computed } from 'vue';
  import type { MpfCareCardProps, MpfCareCardVariant } from './MpfCareCard.props';
  import { mpfCareCardDefaults } from './MpfCareCard.props';
  import './MpfCareCard.scss';
  import './MpfCareCardCore.scss';

  const props = withDefaults(defineProps<MpfCareCardProps>(), mpfCareCardDefaults);

  const VARIANT_PREFIX_MAP: Record<MpfCareCardVariant, string> = {
    'non-urgent': 'Non-urgent advice:',
    urgent: 'Urgent advice:',
    emergency: 'Emergency advice:',
  };

  const baseClass = 'mpf-card mpf-card--care';
  const marginClass = 'mpf-u-margin-top-2';
  const variantClass = computed(() => `mpf-card--care--${props.variant}`);

  const headingTag = computed(
    () => (props.headingLevel ? `h${props.headingLevel}` : 'h2') as keyof HTMLElementTagNameMap,
  );

  const srPrefixComputed = computed(
    () => props.srPrefix ?? VARIANT_PREFIX_MAP[props.variant ?? 'non-urgent'],
  );
</script>

<template>
  <div :class="[baseClass, variantClass, marginClass]">
    <div class="mpf-card--care__heading-container">
      <component :is="headingTag" class="mpf-card--care__heading">
        <span role="text">
          <span class="mpf-u-visually-hidden">
            {{ srPrefixComputed }}
          </span>
          {{ heading }}
        </span>
      </component>
      <span class="mpf-card--care__arrow" aria-hidden="true"></span>
    </div>

    <div class="mpf-card__content">
      <slot>
        <!-- TODO: check &hard code NHS as default-->
        <p><strong>Phone 999 or go to A&amp;E now if you have:</strong></p>
        <ul>
          <li>
            <strong>Signs of a heart attack</strong> (chest pain, pressure, heaviness or tightness
            across the chest)
          </li>
          <li>
            <strong>Signs of a stroke</strong> (face dropping on one side, cannot hold both arms up,
            difficulty speaking)
          </li>
          <li><strong>Sudden confusion</strong> (unsure of own name or age)</li>
          <li><strong>Suicide attempt</strong> (by taking something or self-harming)</li>
          <li>
            <strong>Severe difficulty breathing</strong> (not being able to get words out, choking
            or gasping)
          </li>
          <li><strong>A serious injury</strong> (e.g. after a serious accident)</li>
          <li><strong>Heavy bleeding</strong> (spraying, pouring or enough to make a puddle)</li>
          <li><strong>Severe injuries</strong> (after a serious accident or assault)</li>
          <li>
            <strong>A seizure or fit</strong> (shaking, jerking, or unconscious &amp; can’t be woken
            up)
          </li>
          <li><strong>Sudden, rapid swelling</strong> (of the lips, mouth, throat or tongue)</li>
          <li>
            <strong>Labour or child birth</strong> (waters breaking, more frequent intense cramps
            (contractions), baby coming, or just born)
          </li>
        </ul>
      </slot>
    </div>
  </div>
</template>
